import { render } from "./PhotoPanel.vue?vue&type=template&id=1dc8b4be&scoped=true"
import script from "./PhotoPanel.vue?vue&type=script&lang=js"
export * from "./PhotoPanel.vue?vue&type=script&lang=js"

import "./PhotoPanel.vue?vue&type=style&index=0&id=1dc8b4be&scoped=true&lang=scss"
import "./PhotoPanel.vue?vue&type=style&index=1&id=1dc8b4be&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc8b4be"]])

export default __exports__